module.exports = __webpack_public_path__ + "static/img/shared-betting-history-single-bg.5d5d9d1.png";